<div class="action" *ngIf="header.field == 'action'">
    <button class="btn btn-success" (click)="action('accepted', data.id)">
      Accept
    </button>
    <button ejs-button class="btn btn-danger" (click)="action('rejected', data.id)">
      Reject
    </button>
  </div>
  <div class="action" *ngIf="header.field == 'actions'">
    <button style="width: 20px;height: 20px;" mat-icon-button color="primary"
      (click)="onEdit(data.id, $event)">
      <mat-icon>edit</mat-icon>
    </button>
    <button style="width: 20px;height: 20px;" mat-icon-button color="warn"
      (click)="onDelete(data.id, $event)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
